export const validateRoleLoggedUser = value => {
  let user = JSON.parse(localStorage.user);

  return !!user.get_roles.find(
    ({ role, id }) => role.toUpperCase() === value || id === value
  );
};

export const userIsEjecutivoComercial = () => validateRoleLoggedUser("EJECUTIVO COMERCIAL");
export const userIsAsesorCallCenter  = () => validateRoleLoggedUser("ASESOR CALL CENTER");
export const userIsSeller = () => validateRoleLoggedUser("VENDEDOR");
export const userIsCustomer = () => validateRoleLoggedUser("CLIENTE");
export const userIsSuperAdmin = () => validateRoleLoggedUser(8);
export const userIsTechnicalService = () => validateRoleLoggedUser(4);

export const validateVoucherTypesModificationPermissions = (voucherTypeCode) => {

    const permissions = JSON.parse(localStorage.permissions || '[]');

    const voucherTypesModificationPermissions = JSON.parse(
        localStorage.voucher_types_modification_permissions || '[]'
    );

    const hasModificationPermission = permissions.some(
        el => el.permission === 'Permisos Modificacion'
    );

    if (!hasModificationPermission) {
        return false;
    }

    if (!voucherTypesModificationPermissions.length) {
        return true;
    }

    const allowedVoucherTypeCodes =
        voucherTypesModificationPermissions.map(
            el => String(el.code_voucher_type)
        );

    return allowedVoucherTypeCodes.includes(String(voucherTypeCode));

};


// WEBPACK FOOTER //
// ./src/util/roleFunctions.js